/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './UsersNotification.module.less';
import close from '../../../../../static/img/gray-close.svg';

const UsersNotification = (props) => {
  return (
    <>
      {props.notificationShown ? (
        <div className={styles.container}>
          <div className={styles.spread}>
            <div className={styles.iconWrapper}>{props.icon || null}</div>
            <label className={styles.textWrapper}>{props.text} </label>
          </div>
          <div className={styles.spread}>
            <div className={styles.actionWrapper}>{props.action || null}</div>
            <div className={styles.close} role="button" tabIndex={0} onClick={() => props.removeNotification()}>
              <img src={close} alt="" className={styles.closeImg} />
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

UsersNotification.propTypes = {
  text: PropTypes.string,
  icon: PropTypes.object,
  action: PropTypes.object,
  notificationShown: PropTypes.bool,
  removeNotification: PropTypes.func,
};

export default UsersNotification;
